import getCookieByName from '../../../utils/getCookieByName'
import { isLusiniPluginEnabled } from '../../../features/utils'

const push = (evt: any) => {
  if (!isLusiniPluginEnabled && window.dataLayer) {
    window.dataLayer.push(evt)
  }
}

const token = 'OBIfN'
const oscKey = `osc-${token}`

export function requestError() {
  push({
    event: 'genericEvent',
    eventname: 'odoscope',
    group: 'ERROR',
    trackingId: token
  })
}

export function requestTimeout() {
  push({
    event: 'genericEvent',
    eventname: 'odoscope',
    group: 'TIMEOUT',
    trackingId: token
  })
}

export function goControl() {
  push({
    event: 'genericEvent',
    eventname: 'odoscope',
    group: 'control',
    trackingId: token
  })
}

export function emptyResponse(trackingId: string) {
  push({
    event: 'genericEvent',
    eventname: 'odoscope',
    group: 'EMPTY',
    trackingId: trackingId
  })
}

export function success(trackingId: string) {
  push({
    event: 'genericEvent',
    eventname: 'odoscope',
    group: 'odoscope',
    trackingId: trackingId
  })
}

export function unsupportedRequest() {
  push({
    event: 'genericEvent',
    eventname: 'odoscope',
    group: 'UNSUPPORTED',
    trackingId: token
  })
}
